import { onMounted, getCurrentInstance, onBeforeUnmount } from 'vue-demi';
import { useEnv } from '../use-env';
/**
 * 使用传送
 * @param {HTMLElement} to 传送到的节点
 */
export function useTeleport(to = document.body) {
    const { isPreRender } = useEnv();

    if (!isPreRender && to instanceof HTMLElement) {
        onMounted(() => {
            const $el = getCurrentInstance().proxy.$el;
            $el && to.appendChild($el);
        });
        onBeforeUnmount(() => {
            const $el = getCurrentInstance().proxy.$el;
            $el?.remove();
        });
    }
}
